import React, { useRef, useContext } from "react";
import { BaseListItem } from "./style";
import PropTypes from "prop-types";
import { ThemeContext } from "helpers/contexts.js";
import { customPropEquality } from "helpers/utilities";

ListItem.propTypes = {
  onClick: PropTypes.func,
  borderColor: PropTypes.string,
  isSelected: PropTypes.bool,
  margin: PropTypes.string,
  padding: PropTypes.string,
  propsToMemoize: PropTypes.array,
  activeColor: PropTypes.bool,
  hoverColor: PropTypes.bool,
  onMouseDown: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onDoubleClick: PropTypes.func,
  bgColor: PropTypes.string,
  index: PropTypes.number,
};

ListItem.defaultProps = {
  onClick: null,
  isSelected: false,
  margin: "0",
  padding: "12px 10px",
};

function ListItem(props) {
  const theme = useContext(ThemeContext);
  const hoverColor = props.hoverColor || theme.colors.gray.gray100;
  const activeColor = props.activeColor || theme.colors.gray.gray200;
  const ref = useRef(null);

  let cursor = null;
  let borderColor = props.borderColor || theme.colors.transparent;
  let backgroundColor = null;
  let padding = props.padding;
  let margin = props.margin;
  let borderBottom = null;
  let draggingOverBorder = null;

  if (props.bgColor) {
    backgroundColor = props.bgColor;
  }
  if (props.onClick || props.onMouseDown) {
    cursor = "pointer";
  }

  if (props.isSelected) {
    backgroundColor = activeColor;
  }

  return (
    <BaseListItem
      onClick={props.onClick}
      onMouseDown={props.onMouseDown}
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
      cursor={cursor}
      hoverColor={hoverColor}
      borderColor={borderColor}
      activeColor={activeColor}
      backgroundColor={backgroundColor}
      margin={margin}
      padding={padding}
      theme={theme}
      shadow={
        margin && margin != "0" ? theme.shadow.shadow3 : theme.shadow.none
      }
      onDoubleClick={props.onDoubleClick}
      ref={ref}
      borderBottom={borderBottom}
      draggingOverBorder={draggingOverBorder}
    >
      {props.children}
    </BaseListItem>
  );
}

const areEqual = (previousProps, nextProps) => {
  let excludedProps = [];
  if (previousProps.propsToMemoize) {
    excludedProps = previousProps.propsToMemoize.map((prop) => {
      return {
        name: prop,
        isEqual: true,
      };
    });
    excludedProps.push({ name: "propsToMemoize", isEqual: true });
  }
  return customPropEquality(previousProps, nextProps, excludedProps);
};

export default React.memo(ListItem, areEqual);
